import React from 'react'
import { useTranslation } from 'react-i18next'
import profilePanelStyles from '../../generic/profile-panel/profilePanel.module.scss'
import styles from './playerLevelTooltip.module.scss'
import genericModalStyles from '../../../generic/modalWTN.module.scss'
import cx from 'classnames'
import withInfoModal from 'components/generic/hoc/withInfoModal'

const Title = () => {
  const { t } = useTranslation('strPlayerLevel')

  return <h2 className={profilePanelStyles.title}>{t('title')}</h2>
}

const HeaderWithModal = withInfoModal('player-level-info-modal', Title)

const PlayerLevelTooltip = () => {
  const { t } = useTranslation('strPlayerLevel')

  return (
    <HeaderWithModal
      widgetElId='player-profile'
      modalHeaderText={t('modal.title')}
      modalAcceptBtnText={t('modal.close')}
      wrapperClass={styles.header}
      triggerClass={styles.trigger}
      withBtnsDivider
    >
      <div className={cx(genericModalStyles.body, styles.customBody)}>
        <p className={styles.modalDescription}>{t('modal.description')}</p>

        <div className={styles.modalSection}>
          <strong>{t('modal.sex.title')}</strong>
          <p>{t('modal.sex.description')}</p>
        </div>

        <div className={styles.modalSection}>
          <strong>{t('modal.nationality.title')}</strong>
          <p>{t('modal.nationality.description')}</p>
        </div>

        <div className={styles.modalSection}>
          <strong>{t('modal.ageGroup.title')}</strong>
          <p>{t('modal.ageGroup.description')}</p>
        </div>

        <div className={styles.modalSection}>
          <strong>{t('modal.percentile.title')}</strong>
          <p>{t('modal.percentile.description')}</p>
        </div>

        <p className={styles.modalFooterText}>{t('modal.verifiedOnly')}</p>
      </div>
    </HeaderWithModal>
    // <>
    //   <span onClick={() => setModalShow(true)} className={styles.playerLevelInfoIcon}>
    //     <InfoIcon />
    //   </span>

    //   <Modal
    //     isOpen={modalShow}
    //     onRequestClose={() => setModalShow(false)}
    //     closeTimeoutMS={500}
    //     className={cx(genericModalStyles.modalWrapper, styles.customModalWrapper)}
    //     portalClassName='modal-wtn-portal'
    //     appElement={document.querySelector('main') as HTMLElement}
    //   >
    //     <h2
    //       className={cx(
    //         genericModalStyles.header,
    //         genericModalStyles.reducedMargin,
    //         styles.customHeader
    //       )}
    //     >
    //       {t('modal.title')}
    //     </h2>

    //     <hr className={styles.modalDivider} />

    //     <div className={styles.buttonContainer}>
    //       <button onClick={() => setModalShow(false)} className={styles.customCloseButton}>
    //         <p>{t('modal.close')}</p>
    //       </button>
    //     </div>
    //   </Modal>
    // </>
  )
}

export default PlayerLevelTooltip
